import { TimePeriod } from '~/Api/User/ExchangeRate';

import CustomRates from './CustomRates';
import RatesSettings from './RatesSettings';

interface RawRatesSettings {
	type: string;
	name: string;
	date: string | null;
	customExchangeRates: {
		id: string;
		name: string;
		baseCurrency: string;
	} | null;
	timePeriod: TimePeriod;
}

export default function mapRatesSettings(settings: RawRatesSettings): RatesSettings {
	return new RatesSettings(
		settings.type,
		settings.name,
		settings.date !== null ? new Date(settings.date) : null,
		settings.customExchangeRates !== null
			? new CustomRates(
					settings.customExchangeRates.id,
					settings.customExchangeRates.name,
					settings.customExchangeRates.baseCurrency
			  )
			: null,
		settings.timePeriod
	);
}
